export default __webpack_public_path__ + "static/media/Covenant_Health.f7dd0e9b.png";